@if (previewDialog || inputDialog) {
  <div xmlns="http://www.w3.org/1999/html"
    class="fixed w-screen h-screen bg-gray-600 top-0 bottom-0 left-0 right-0 overflow-hidden bg-opacity-60 z-30">
    <div class="h-full w-full flex justify-center items-center p-4">
      @if (previewDialog) {
        <div class="bg-white px-[32px] rounded-[8px] absolute w-3/5 p-4 2xl:w-2/5">
          <div class="flex justify-between items-center">
            <b>{{previewProblemTemplate.problemtemplate_name}}</b>
            <button (click)="previewDialog = false" class="text-sm rounded-full h-8 w-8 hover:bg-gray-200" aria-label="Close Question Preview">
              <fa-icon [icon]="faXmark" />
            </button>
          </div>
          <div class="overflow-y-auto max-h-[650px]">
            @if (previewProblemTemplate.mathjax) {
              <div [mathjax]="previewProblemTemplate.question_text" class="mb-2"></div>
            }
            @if (!previewProblemTemplate.mathjax) {
              <div [innerHTML]="previewProblemTemplate.question_text" class="my-1"></div>
            }
            @if (previewProblemTemplate.type === 'MULTIPLECHOICE') {
              <multiple-choice [problem_template]="previewProblemTemplate" [review]="true" />
            }
            @if (previewProblemTemplate.type === 'PASSAGE' || previewProblemTemplate.type === 'MULTIFIELD') {
              <multifield [problem_template]="previewProblemTemplate" [review]="true" />
            }
          </div>
        </div>
      }
      @if (inputDialog) {
        <div class="bg-white px-[32px] rounded-[8px] absolute w-[700px] p-2">
          <div class="flex justify-between">
            <p><b>Hello Inputs</b></p>
            <button (click)="inputDialog = false" class="text-sm rounded-full h-8 w-8 hover:bg-gray-200" aria-label="Close Inputs">
              <fa-icon [icon]="faXmark" />
            </button>
          </div>
          <div>
            <!-- TODO make input form for this -->
            <div class="text-[#8B96A2] text-[12px]">
              Name
            </div>
            <input class="mt-[6px] w-full input" placeholder="Enter name" />
          </div>
          <div class="my-2 text-[#8B96A2] text-[12px]">
            Description
          </div>
          <textarea class="w-full input" placeholder="Enter description"></textarea>
        </div>
      }
    </div>
  </div>
}
<div cdkDropList (cdkDropListDropped)="drop($event)">
  @for (poolQuestionForm of questions.controls; track poolQuestionForm; let i = $index) {
    <div class="rounded-[8px] mr-[11px] border border-[#74808B] pb-[21px] mt-[17px] bg-white" cdkDrag>
      <div class="flex justify-between bg-white p-[10px] rounded-[8px]">
        <div class="flex">
          <button>
            <fa-icon [icon]="faBars" class="mr-[8px]"/>
          </button>
          Question {{i+1}}
        </div>
        <button (click)="removeQuestion(i)" class="hover:bg-gray-200 rounded-full w-[24px] h-[24px]">
          <fa-icon [icon]="faXmark" />
        </button>
      </div>
      <div class="mx-[10px] mt-[24px]">
        @if (addedProblemTemplate[i] != undefined) {
          <div class="flex justify-center">
            <div class="flex-grow">
              <dropdown-search (singleItemChange)="updateProblemTemplateID(poolQuestionForm, i)" [items]="problemTemplates" [addedList]="addedProblemTemplate[i]" [singleItemList]="true" placeholder="Search for PT by name"/>
            </div>
            <button class="rounded-[6px] px-3 py-1 hover:bg-gray-200 text-zinc-400 ml-1 text-[14px]" (click)="openPreviewDialog(poolQuestionForm)">
              <fa-icon [icon]="faEye" class="ml-1" />
              Preview
            </button>
            <!-- <button
            *ngIf="addedProblemTemplate[i].length > 0 && addedProblemTemplate[i][0].answer_type === 'PROGRAMMING'"
            (click)="openEditInputVariables(addedProblemTemplate[i][0].problemtemplate_id)"
            tooltip="Edit"
            class="rounded-[6px] px-3 py-1 hover:bg-gray-200 text-zinc-400 ml-1 text-[14px]"
            >
            <fa-icon [icon]="faPencil" />
          </button> -->
        </div>
      }
      @if (poolQuestionForm.get('problemtemplate_id')?.value != null) {
        <div class="text-zinc-500 text-[12px]">Current PT ID is {{poolQuestionForm.get('problemtemplate_id')?.value}}</div>
      }
    </div>
  </div>
  }
</div>

<div class="flex justify-center mt-[20px]">
  <full-button (click)="addNewQuestion()" text="Add Question" />
</div>
